
export const handlerLoaderVisibility = (display) => async dispatch => {

    if (display) {
        dispatch({type: "DISPLAY_LOADER_SPINNER"});
    } else {
        dispatch({type: "HIDE_LOADER_SPINNER"});
    }
};
